<script setup>
import OnlineProcurementBar from '@/components/Generics/OnlineProcurementBar.vue'
import ExtranetBar from '@/components/Generics/ExtranetBar.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

</script>

<template>

  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <ExtranetBar></ExtranetBar>
    <OnlineProcurementBar></OnlineProcurementBar>
    <div class="container-fluid border-top bg-white hide-desktop">
      <span class="fs-6 text-dark sidebar-mobile-toggle p-2"
            @click="$emit('toggle-sidebar')"
      >
        <template class="d-flex align-items-center align-content-center">
        <font-awesome-icon icon="fa-bars"/>
        <span class="ps-2 text-gray">Menu</span>
        </template>
      </span>
    </div>
  </nav>

</template>

<style scoped>

</style>
